<!-- <div [ngClass]="{'indicator': restful.indicator$ | async}"></div> -->
<router-outlet></router-outlet>
